import React from 'react';
import type { NextPage } from 'next';
import Layout from '@/components/Layout';

import AwardsLayout from '@/containers/awards/AwardsLayout';

const Awards: NextPage = () => (
  <Layout title="PE/VC Awards" description="" url="awards">
    <AwardsLayout />
  </Layout>
);

export default Awards;
